<template>
 <div>
  <div>
    <!-- <h2>Pergamin Organic</h2> --> 
    <div class="d-flex flex-row">
      <div class="maiuscula p-1"> <p class="nome">Pergamin</p></div>
      <div class="p-2"> <p class="desc">todas as suas tarefas em uma mesma tela</p></div>
    </div>
    <div class="d-flex flex-row">
      <div class="maiuscula p-1"><p class="nome">Organic</p></div>
      <div class="p-2"> <p class="desc"> diferentes funções interconectadas, como um organismo vivo </p></div>
    </div>
    <b-img :src="require('../assets/pergamin_borrado.jpg')" fluid width="800"></b-img>
    
    <h3 class="maiuscula font-weight-light bronze">Novo conceito</h3>
    <p>Solução para serviços em saúde focada na integração entre atendimento ao cliente, financeiro, e integração com equipamentos hospitalares e ambulatoriais. Tudo em um.</p>
    <h3 class="maiuscula font-weight-light bronze">Usabilidade</h3>
    <p>Simplicidade de uso, compatibilidade e acesso on-line.</p>
    <h3 class="maiuscula font-weight-light bronze">Muitos recursos</h3>
    <p>Cadastro inclusivo do cliente, gestão financeira, expedição de notas fiscais, integração com protocolos DICOM, marcação de exames on-line, laudos on-line, envio de mensagens e-mail, SMS e WhatsApp aos clientes, tudo na mesma plataforma.</p>
    <h3 class="maiuscula font-weight-light bronze">Segurança</h3>
    <p>Proteção avançada de bancos de dados de clientes e colaboradores. Sistema de integração simultânea com nuvem, prevenindo contra perda de dados e interrupções no atendimento.</p>
    <h3 class="maiuscula font-weight-light bronze">Suporte</h3>
    <p>Suporte personalizado disponível para cidade de Porto Alegre-RS e região metropolitana. <router-link to="/contato" class="linkbold">Consulte.</router-link></p>
    <h3 class="maiuscula font-weight-light bronze">Como assinar</h3>
    <p><router-link to="/contato" class="linkbold">Fale conosco</router-link> para saber os valores e condições disponíveis para você e para a sua empresa.</p>
  </div>
  <div style="width:100%; height:100%; color:white; font-size:1.5rem">. </div>
 </div>
</template>

<script>
export default {};
</script>

<style scoped>

.desc{
    font-weight: bold;
    color:rgb(168, 124, 0) ;
}
.nome{
    font-size: 1.35rem;
}


</style>